module.exports = __webpack_public_path__ + "img/YjzEgoL9jd8z3VSHS6og5WMnJ6T9GV9h6lhy7OD8.a4c81cf2.jpg";